import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { ColumnsConfig, TableConfig, TableData } from 'sct-custom-table/sct-table/projects/sct-table/src/lib/custom-table-interface';
import { DeviceService } from '../../device/device.service';
import { DeviceFactory } from '../../device/device-factory/device-factory';
import { CommonService, TimeSource } from 'src/app/shared/services/common.service';
import { DecimalPipe } from '@angular/common';

@Component({
	selector: 'app-charger-usage-data',
	templateUrl: './charger-usage-data.component.html',
	styleUrls: ['./charger-usage-data.component.css']
})
export class ChargerUsageDataComponent {
	@Input() device: any = {};
	@Input() currentSite: any = {};
	@Input() studyInfo: any = {};

	maxDate = new Date((new Date()).getTime() - 24 * 60 * 60 * 1000); // yesterday
	toDate = this.maxDate // yesterday
	fromDate = new Date((new Date()).getTime() - 30 * 24 * 60 * 60 * 1000); // 30 days ago
	minDate = this.fromDate;

	/** Which time zone each time column is rendered in. See ST-2326. */
	private readonly timeSourceByColumn: Record<string, TimeSource> = {
		// Day buckets are cut in the device zone - see DAO/dailyDetailsDAO.js.
		day: TimeSource.Device,
	};

	columnConfig: ColumnsConfig[] = [
		{key: 'day', name: this.translate.instant('g.date'), type: 'date'},
		{key: 'total_charge_hour', name: this.translate.instant('chargers_performance.total_charge_hour'), type: 'number'},
		{key: 'total_idle_hours', name: this.translate.instant('chargers_performance.total_idle_hours'), type: 'number'},
		{key: 'total_off_time_hours', name: this.translate.instant('chargers_performance.total_off_time_hours'), type: 'number'},
		{key: 'total_charge_ah', name: this.translate.instant('chargers_performance.total_charge_ah'), type: 'number'},
		{key: 'total_charge_kwh', name: this.translate.instant('chargers_performance.total_charge_kwh'), type: 'number'},
	];

	tableData: TableData[] = [];
	tableConfig: TableConfig = {
		hasExport: true,
		hasPagination: true,
		pageSize: 100,
		fitScreen: true,
		hideNoData: true,
		draggable: true,
		fileName: this.translate.instant('chargers_performance.daily_charger_usage_report'),
		csvFileHeaderInfo: []
	};

	constructor(
		private deviceService: DeviceService,
		private translate: TranslateService,
		private commonService: CommonService,
	) {}

	ngOnInit() {
		this.commonService.applyTimeSourceTooltips(this.columnConfig, this.timeSourceByColumn);

		if (this.device?.config_info?.installation_date)
			this.minDate = moment.utc(this.device.config_info.installation_date * 1000).startOf('day').toDate();

		this.getDailyChargerUsageReport();
	}

	ngOnChanges(changes){
		if(changes.device && this.device)
			this.getDailyChargerUsageReport();
	}

	changeDate(field, value) {
		this[field] = value;

		this.getDailyChargerUsageReport();
	}

	getDailyChargerUsageReport() {
		const zoneDiff	= new Date().getTimezoneOffset() * -1;
		let fromDate:any	= new Date(new Date(this.fromDate).getTime() + (zoneDiff * 60 * 1000));
		let toDate:any = new Date(new Date(this.toDate).getTime() + (zoneDiff * 60 * 1000));
		fromDate = moment(fromDate).utc().startOf('day').unix();
		toDate = moment(toDate).utc().endOf('day').unix();

		const decimalPipe: DecimalPipe = new DecimalPipe("en-US");

		this.deviceService.getDailyDeviceUsageReport(fromDate, toDate, this.device.mac_address, DeviceFactory.types.charglink, 0, this.studyInfo?.id || 0).subscribe((res: any) => {
			const tableData = [];

			for (const day in res) {
				if (res.hasOwnProperty(day)) {
					tableData.push({
						day: {value: res[day].day},
						total_charge_hour: {value: Math.round((res[day].total_charge_second || 0) / 3600).toLocaleString()},
						total_idle_hours: {value: Math.round((res[day].total_idle_second || 0) / 3600).toLocaleString()},
						total_off_time_hours: {value: Math.round((res[day].total_off_time_second || 0) / 3600).toLocaleString()},
						total_charge_ah: {value: Math.round((res[day].total_as || 0) / 3600).toLocaleString()},
						total_charge_kwh: {value: Math.round((res[day].total_ws || 0) / (3600 * 1000)).toLocaleString()},
					});
				}
			}

			this.tableData = tableData;
			this.tableConfig.csvFileHeaderInfo = this.commonService.getCsvFileHeadersInfo({
				customerName: this.currentSite.customer_name,
				siteName: this.currentSite.name,
				deviceSN: this.device.serial_number,
				includeSpacing: false
			});
		});
	}
}
